function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Box } from '@chakra-ui/layout';
import { StylesProvider, useMultiStyleConfig, useStyles, useTheme } from '@chakra-ui/system';
import React from 'react';

var Menu = props => {
  var {
    className,
    cx,
    children,
    innerProps,
    innerRef,
    placement,
    selectProps: {
      chakraStyles
    }
  } = props;
  var menuStyles = useMultiStyleConfig('ChakraReactSelect', {});

  var initialStyles = _extends({
    position: 'absolute'
  }, placement === 'bottom' && {
    top: '100%'
  }, placement === 'top' && {
    bottom: '100%'
  }, {
    marginY: '8px',
    width: '100%',
    zIndex: 1,
    overflow: 'hidden'
  });

  var sx = chakraStyles != null && chakraStyles.menu ? chakraStyles.menu(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: cx({
      menu: true
    }, className),
    ref: innerRef,
    sx: sx
  }, innerProps), /*#__PURE__*/React.createElement(StylesProvider, {
    value: menuStyles
  }, children));
};

var MenuList = props => {
  var {
    className,
    cx,
    innerRef,
    children,
    maxHeight,
    isMulti,
    selectProps: {
      size,
      chakraStyles
    }
  } = props;
  var {
    list
  } = useStyles();
  var borderRadii = useTheme().radii;

  var initialStyles = _extends({}, list, {
    maxHeight: maxHeight + "px",
    overflowY: 'auto',
    borderRadius: borderRadii[size]
  });

  var sx = chakraStyles != null && chakraStyles.menuList ? chakraStyles.menuList(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, {
    className: cx({
      'menu-list': true,
      'menu-list--is-multi': isMulti
    }, className),
    ref: innerRef,
    sx: sx
  }, children);
};

var LoadingMessage = props => {
  var {
    children,
    className,
    cx,
    innerProps,
    selectProps: {
      size,
      placeholderColor,
      chakraStyles
    }
  } = props;
  var fontSizes = {
    xs: '0.875rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem'
  };
  var paddings = {
    xs: '6px 9px',
    sm: '6px 9px',
    md: '8px 12px',
    lg: '10px 15px'
  };
  var initialStyles = {
    color: placeholderColor,
    textAlign: 'center',
    padding: paddings[size],
    fontSize: fontSizes[size]
  };
  var sx = chakraStyles != null && chakraStyles.loadingMessage ? chakraStyles.loadingMessage(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: cx({
      'menu-notice': true,
      'menu-notice--loading': true
    }, className),
    sx: sx
  }, innerProps), children);
};

var NoOptionsMessage = props => {
  var {
    children,
    className,
    cx,
    innerProps,
    selectProps: {
      size,
      placeholderColor,
      chakraStyles
    }
  } = props;
  var fontSizes = {
    xs: '0.875rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem'
  };
  var paddings = {
    xs: '6px 9px',
    sm: '6px 9px',
    md: '8px 12px',
    lg: '10px 15px'
  };
  var initialStyles = {
    color: placeholderColor,
    textAlign: 'center',
    padding: paddings[size],
    fontSize: fontSizes[size]
  };
  var sx = chakraStyles != null && chakraStyles.noOptionsMessage ? chakraStyles.noOptionsMessage(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({
    className: cx({
      'menu-notice': true,
      'menu-notice--no-options': true
    }, className),
    sx: sx
  }, innerProps), children);
};

export { LoadingMessage, MenuList, NoOptionsMessage };
export default Menu;
//# sourceMappingURL=menu.js.map